import React from 'react';
import MentalKnowHowText from './MentalKnowHowText';
import withMentalPageElements, { MentalPageProps } from '../../components/MentalPageWrapper';
import LinkManager from '../../lib/LinkManager';
import MentalApi from '../../lib/MentalApi';
import { WrapperMatchParams } from '../../components/MentalPageWrapper/MentalPageWrapper';
import { MentalKnowHowTextData } from '../../types';

interface MatchParams extends WrapperMatchParams {
    knowHowIndex: string,
}

interface Props extends MentalPageProps<MatchParams, MentalKnowHowTextData> {
    data: MentalKnowHowTextData,
}

const MentalKnowHowTextWithData: React.FC<Props> = ({ data }: Props) => (
    <MentalKnowHowText knowHowText={data} />
);

export default withMentalPageElements(MentalKnowHowTextWithData,
    {
        backLinkProvider: mental => LinkManager.getKnowHowIndexLink(mental),
        pageLayoutProvider:
            mentalLinkIdentifier => MentalApi.getMentalKnowHowPageLayout(
                mentalLinkIdentifier.mentalId,
            ),
        dataLoader: (mentalLinkIdentifier, matchParams: MatchParams) => {
            const id = Number(matchParams.knowHowIndex);
            const data = MentalApi.getKnowHowText(mentalLinkIdentifier, id);

            return data;
        },
    });
